export const baseUrl = "https://planque-backend.onrender.com";
// export const baseUrl = "127.0.0.1:8000";

export default baseUrl;
